import type { BlobLike } from "@pdfking/compatibility"

import type { Page } from "../geometry/Page"
import type { PlottingContext } from "../options/PlottingContext"

export type PDFPlotFunction = (
  pages: Page[],
  context?: PlottingContext
) => AsyncGenerator<BlobLike>
